import { getDxpAuthHeaders } from "@/config/apollo";

export function apiFetch(
  accountId: string | null | undefined,
  input: RequestInfo | URL,
  init: RequestInit = {}
): Promise<Response> {
  const headers = new Headers(getDxpAuthHeaders(accountId));
  if (init.headers) {
    new Headers(init.headers).forEach((value, key) => {
      headers.set(key, value);
    });
  }
  return fetch(input, { ...init, headers });
}
